import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import { LookupCursadasAlumnos } from '../Cursadas/LookupCursadasAlumnos';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

function formatPeriodoCursada(periodoCursadaDescripcion) {
  if (periodoCursadaDescripcion === '1') return 'Primer Cuatrimestre';
  if (periodoCursadaDescripcion === '2') return 'Segundo Cuatrimestre';
  return 'Anual';
}

function formatEstadoInscripcion(estado) {
  if (estado === 'A') return 'Activa';
  if (estado === 'P') return 'Pendiente';
  if (estado === 'G') return 'Acta Generada';
  return 'Lista';
}

export class UpdateInscripcionCursadaAlumno extends Component {
  static displayName = UpdateInscripcionCursadaAlumno.name;

  constructor(props) {
    super(props);
    this.state = {
      loadingInitial: true,
      loading: false,
      loadError: '',
      errorMessage: '',
      redirect: false,
      showLookupCursada: false,
      cursada: {
        cursadaCodigo: 0,
        cursadaMateriaCodigo: '',
        cursadaMateriaNombre: '',
        cursadaPeriodo: '',
      },
      alumno: {
        alumnocarreraCod: 0,
        alumnoNombre: '',
        alumnoCarrera: 0,
        alumnoCarreraNombre: '',
      },
      id: this.props.match.params.id,
      details: this.props.match.params.details,
      descripcion: '',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  get isReadOnly() {
    return this.state.details === '1';
  }

  async componentDidMount() {
    if (constantClass.canAccess('InscribirCursada')) {
      await this.populateData();
    } else {
      this.setState({ loadingInitial: false });
    }
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleShowCursadaLookup = () => {
    if (!this.state.loading && !this.isReadOnly) {
      this.setState({ showLookupCursada: true });
    }
  };

  handleHideLookup = () => {
    this.setState({ showLookupCursada: false });
  };

  handleCursadaAnioItem = (e) => {
    const anioProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      cursada: {
        cursadaCodigo: anioProperties[0],
        cursadaMateriaCodigo: anioProperties[5],
        cursadaMateriaNombre: anioProperties[1],
        cursadaPeriodo: formatPeriodoCursada(anioProperties[3]) + '-' + anioProperties[4],
      },
      showLookupCursada: false,
    });
  };

  isFormValid() {
    return this.state.descripcion.length > 0;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.isReadOnly) {
      this.setState({ redirect: true });
      return;
    }
    if (isSubmitInProgress(this.state.loading)) return;
    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Todos los campos son obligatorios.' });
      return;
    }
    this.saveStudent();
  }

  async populateData() {
    this.setState({ loadingInitial: true, loadError: '' });

    const { data } = await constantClass.apiFetch('api/ic/' + this.state.id, {
      method: 'GET',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || !data.returnModel) {
      this.setState({
        loadingInitial: false,
        loadError: constantClass.getApiErrorMessage(
          data,
          'No se pudieron cargar los datos de la inscripción.'
        ),
      });
      return;
    }

    const model = data.returnModel;
    this.setState({
      loadingInitial: false,
      cursada: {
        cursadaCodigo: model.cursadaCod,
        cursadaMateriaCodigo: model.cursadaCodNavigation.materiaCarreraCod,
        cursadaMateriaNombre: model.cursadaCodNavigation.materiaNombre,
        cursadaPeriodo: formatPeriodoCursada(model.cursadaCodNavigation.periodoCursadaDescripcion)
          + ' - '
          + model.cursadaCodNavigation.anioAcademicoDescripcion,
      },
      alumno: {
        alumnocarreraCod: model.alumnoxCarreraCodNavigation.alumnoxCarreraCod,
        alumnoNombre: model.alumnoxCarreraCodNavigation.alumnoNombre,
        alumnoCarrera: model.alumnoxCarreraCodNavigation.carreraCod,
        alumnoCarreraNombre: model.alumnoxCarreraCodNavigation.carreraNombre,
      },
      descripcion: model.inscripcionCursadaEstado,
    });
  }

  async saveStudent() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/ic', {
      method: 'PUT',
      body: JSON.stringify({
        CursadaCod: this.state.cursada.cursadaCodigo,
        AlumnoxCarreraCod: this.state.alumno.alumnocarreraCod,
        MateriaCarreraCod5: this.state.cursada.cursadaMateriaCodigo,
        InscripcionCursadaCod: this.state.id,
        InscripcionCursadaEstado: this.state.descripcion,
        IgnorarCorrelatividad: false,
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo actualizar la inscripción. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-ica" />;
    }

    const {
      loadingInitial,
      loading,
      loadError,
      alumno,
      cursada,
      showLookupCursada,
      errorMessage,
      descripcion,
    } = this.state;

    const isBusy = loading;
    const title = this.isReadOnly ? 'Ver datos de Inscripción a Cursar' : 'Modificar datos de Inscripción a Cursar';
    const alumnoDisplay = alumno.alumnoNombre + ' - ' + alumno.alumnoCarreraNombre;
    const cursadaDisplay = cursada.cursadaMateriaNombre.trim() + ' - ' + cursada.cursadaPeriodo;

    if (loadingInitial) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-ica">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <p className="md-form-page__skeleton"><em>Cargando datos...</em></p>
        </div>
      );
    }

    if (loadError) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-ica">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <div className="md-form-page__error" role="alert">{loadError}</div>
        </div>
      );
    }

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-ica">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">{title}</h1>
        <p className="md-form-page__subtitle">
          {this.isReadOnly
            ? 'Consulta los datos registrados de tu inscripción a cursada.'
            : 'Actualice la materia de la inscripción y confirme los cambios.'}
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Actualizando inscripción, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Alumno</span>
              <input
                className="md-form-page__input"
                type="text"
                value={alumnoDisplay}
                disabled
                readOnly
                aria-label="Alumno"
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Materia</span>
              {!this.isReadOnly ? (
                <button
                  type="button"
                  className="md-form-page__pick-btn"
                  onClick={this.handleShowCursadaLookup}
                  disabled={isBusy}
                >
                  Seleccione la Materia
                </button>
              ) : null}
              {showLookupCursada ? (
                <LookupCursadasAlumnos
                  alumnoCarreraCod={alumno.alumnocarreraCod}
                  carreraCod={alumno.alumnoCarrera}
                  selectItem={this.handleCursadaAnioItem}
                  hideLookup={this.handleHideLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={cursadaDisplay}
                disabled
                readOnly
                aria-label="Materia"
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Estado de la Inscripción</span>
              <input
                className="md-form-page__input"
                type="text"
                value={formatEstadoInscripcion(descripcion)}
                disabled
                readOnly
                aria-label="Estado de la inscripción"
              />
            </div>

            <div className="md-form-page__actions">
              <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
